import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "row", "count"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()
    let visible = 0

    this.rowTargets.forEach(row => {
      const text = row.dataset.searchText || row.textContent.toLowerCase()
      const match = !query || text.includes(query)
      row.style.display = match ? "" : "none"
      if (match) visible++
    })

    if (this.hasCountTarget) {
      this.countTarget.textContent = `${visible} result${visible === 1 ? '' : 's'}`
    }
  }
}
